import React from "react";
import { useTranslation } from "react-i18next";
import { CartesianGrid, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import "../../i18n";
import { TemporalSelectorModes } from "../../layouts/TemporalSelector/TemporalSelector";
import CustomTooltip from "./CustomTooltip";
import DashboardChartWrapper from "./dashboardChartWrapper.component";
import { DashboardDailyData } from "./DashboardComponent";
import DashboarcComponentTitle from "./DashboardComponentTitle";
import { DailyAggregateData, IDashboardDailyProps } from "./DashboardDailySells";

export interface IDashboardDailyCoversProps {
	data: DashboardDailyData;
	reportCaption: string;
}

const DashboardDailyCovers: React.FC<IDashboardDailyCoversProps & IDashboardDailyProps> = (props) => {
	const { t } = useTranslation();

	const covers_num_translated = t("zreports.zreport.totalCoversNumber");

	const title =
		props.mode === TemporalSelectorModes.week ? t("dashboard.titles.weekly.total_covers_number") : t("dashboard.titles.monthly.total_covers_number");

	return (
		<DashboardChartWrapper>
			<DashboarcComponentTitle title={title} />
			<ResponsiveContainer height={160} className={props.responsiveContainerClassName}>
				<LineChart data={props.data.aggregates} margin={{ left: -20, top: 10 }}>
					<CartesianGrid />

					<XAxis dataKey="dateDay" />
					<Tooltip
						labelFormatter={() => covers_num_translated}
						content={({ payload, label, active }: { payload: DailyAggregateData; label: string; active: boolean }) => (
							<CustomTooltip
								payload={payload}
								label={label}
								active={active}
								colorCurrent="#8884d8"
								colorPrevious="#888412"
								payloadCurrentKey={"cover_num"}
								payloadPreviousKey={"cover_num_compare"}
								mode={props.mode}
							/>
						)}
					/>
					<YAxis tick={{ fontSize: 18 }} />
					<Line name={t("shared.period").toString()} type="monotone" dataKey="cover_num" strokeWidth={2} stroke="#8884d8" activeDot={{ r: 8 }} />
					<Line name={t(props.compareLegendLabel).toString()} type="monotone" dataKey="cover_num_compare" strokeWidth={1} stroke="#888412" />
				</LineChart>
			</ResponsiveContainer>
		</DashboardChartWrapper>
	);
};

export default DashboardDailyCovers;
